import { createFileRoute } from '@tanstack/react-router';

import { StudioGallery } from '~/features/setup-studio/dev/studio-gallery';

/** The setup studio in its states, with the network stubbed. A developer page, open to anyone. */
export const Route = createFileRoute('/dev/studio')({ component: StudioGallery });
